import { encryptMessageText, isCiphertextPayload } from '../crypto/messagePayload.ts';

export type ReplySnapshot = {
  id: string | number;
  sender?: string;
  text?: string;
};

export type ReplyPayload = {
  id: string | number;
  sender?: string;
  text: string;
};

export type BuildReplyPayloadOptions = {
  encrypt: boolean;
  key: CryptoKey | null;
};

export async function buildReplyPayload(
  replyTo: ReplySnapshot | null | undefined,
  options: BuildReplyPayloadOptions
): Promise<ReplyPayload | undefined> {
  if (!replyTo || replyTo.id == null) return undefined;

  let replyText = String(replyTo.text || '').slice(0, 280);
  if (options.encrypt && options.key && replyText && !isCiphertextPayload(replyText)) {
    replyText = await encryptMessageText(options.key, replyText);
  }

  return {
    id: replyTo.id,
    sender: replyTo.sender,
    text: replyText
  };
}
